/**
 * The Laneful sending host each Firebase project CNAME/TXT-authenticates
 * against. Client `Config.laneful_domain` and the server's `lanefulDomain()`
 * both read this map so a Cloudflare write cannot target a different
 * environment than the Domains page shows.
 *
 * `LANEFUL_DOMAIN` in `.env.goodsender-*` overrides the server at deploy time
 * without a frontend rebuild (same shape as `CUSTOM_DOMAIN_A_RECORD_IP`).
 */
export const LANEFUL_DOMAIN_BY_PROJECT_ID = {
  "goodsender-prod": "net.goodsender.com",
  "goodsender-dev": "net.dev.goodsender.com",
} as const;
